export default class CVSlide {
    constructor(slide) {
        this.slide = slide;
        this.nextbtn = slide.querySelector('[data-next]');
        this.rangeSlider = slide.querySelector('[data-range-slider] input');
        this.dropdowns = slide.querySelector('[data-dropdowns]');

        this.selects = this.dropdowns.querySelectorAll('select');

        this.selects.forEach((select) => {
            select.addEventListener('change', this.changedInput.bind(this));
        })

        this.brandDropdown = this.dropdowns.querySelector('[data-dropdown-brand]');
        this.brandDropdown.addEventListener('change', this.brandSelection.bind(this));

        this.typeDropdown = this.dropdowns.querySelector('[data-dropdown-type]');

        this.desktop = window.matchMedia('(hover: hover) and (pointer: fine)');

        this.infoBtns = slide.querySelectorAll('[data-info]');
        this.infoBtns.forEach((infobtn) => {
            infobtn.addEventListener('click', function(e) {
                e.preventDefault();
                this.classList.toggle('show');
            });

            if (this.desktop.matches) {
                infobtn.addEventListener('mouseover', function(e) {
                    this.classList.add('show');
                });
    
                infobtn.addEventListener('mouseout', function(e) {
                    this.classList.remove('show');
                });
            }

        })
    }

    changedInput() {
        this.nextbtn.disabled = !this.validate();
    }

    brandSelection() {
        this.typeDropdown.innerHtml = '';
        const options = window.cvtypes[this.brandDropdown.value];
        let index = 0;
        for (const option in options) {
            this.typeDropdown[index] = new Option(options[option], option);
            index += 1;
        }
    }

    validate() {
        let valid = this.brandDropdown.value.length > 0;
        
        return valid;
    }

    getValue() {
        return this.rangeSlider.value;
    }

    toggleInfoWindow(e) {
        e.preventDefault();
        e.target.classList.toggle('show');
    }
}